import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import Testimonials from "./components/Testimonials";

function App() {
  return (
    <div className="App">
      <Navbar />
	  <Hero />
      <CTA />
	  <Testimonials />
      <Footer />
    </div>
  );
}

export default App;
